import axios from 'axios';

export function registerUser(user) {
    return axios.post('signUp', user);
}

export function validatePartnerToken(token) {
    return axios.get('/signup/' + token + '/validatepartner');
}

export function registerInvitedUser(payload) {
    return axios.post('signUp/user', payload);
}
